import { useSportContext } from '@sorare/core/src/contexts/sport';

import { MarketHomePage } from '@sorare/marketplace/src/components/market-home/MarketHomePage';

const MarketHome = () => {
  const { sport } = useSportContext();
  return <MarketHomePage sport={sport} />;
};

export default MarketHome;
